import MemberEmailTemplates from '../../pages/share_templates/library/MemberShareTemplates';
import MemberEmailTemplateDashboard from '../../pages/share_templates/library/MemberShareTemplateDashboard';
import CreateShareTemplate from '../../pages/share_templates/CreateShareTemplate';
import EditShareTemplate from '../../pages/share_templates/EditShareTemplate';
import store from '../../store';
import {authGuard} from '../guards';

// MLD-3150
function gate() {
  return store.getters.canManageShareTemplates;
}

function getRoutes(routePrefix, layout) {

  let basePath = (routePrefix === 'library')
    ? '/v2/app/content/email-templates'
    : '/v2/mobile/mailgun'

  return [
    { // MLD-3150
      name: `${routePrefix}.share_templates.index`,
      path: `${basePath}`,
      component: MemberEmailTemplates,
      meta: {
        layout: layout,
        title: `Email Templates`,
        allow_restricted_user: false,
        gate: gate,
      }
    },
    {
      name: `${routePrefix}.share_template.create`,
      path: `${basePath}/create`,
      component: CreateShareTemplate,
      meta: {
        layout: layout,
        title: `New Email Template`,
        allow_restricted_user: false, // MLD-2750
        gate: gate,
      }
    },
    {
      name: `${routePrefix}.share_template.edit`,
      path: `${basePath}/:templateID(\\d+)/edit`,
      component: EditShareTemplate,
      meta: {
        layout: layout,
        title: `Edit Email Template`,
        allow_restricted_user: false, // MLD-2750
        gate: gate,
      }
    },
    {
      name: `${routePrefix}.share_template.dashboard`,
      path: `${basePath}/:templateID(\\d+)/dashboard`,
      component: MemberEmailTemplateDashboard,
      meta: {
        layout: layout,
        title: `Template Performance`,
        allow_restricted_user: false,
      }
    }
  ]
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]
